"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var react_apollo_1 = require("react-apollo"); // eslint-disable-next-line react/prefer-stateless-function


var QueryTypeClass =
/** @class */
function (_super) {
  tslib_1.__extends(QueryTypeClass, _super);

  function QueryTypeClass() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return QueryTypeClass;
}(React.Component);

exports.Query = react_apollo_1.Query;